import { Contracts } from '../types';

const contracts: Contracts = {
  merkleRedeem: '0x6d19b2bF3A36A61530909Ae65445a906D98A2Fa8',
  merkleOrchard: '0xdAE7e32ADc5d490a43cCba1f0c736033F2b4eFca',
  merkleOrchardV2: '0xE3881627B8DeeBCCF9c23B291430a549Fc0bE5F7',
  multicall: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
  authorizer: '0xA331D84eC860Bf466b4CdCcFb4aC09a1B43F3aE6',
  vault: '0xBA12222222228d8Ba445958a75a0704d566BF2C8',
  weightedPoolFactory: '0x897888115Ada5773E02aA29F775430BFB5F34c51',
  stablePoolFactory: '0xc66Ba2B6595D3613CCab350C886aCE23866EDe24',
  weth: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  rETH: '0xae78736Cd615f374D3085123A210448E74Fc6393',
  stMATIC: '',
  stETH: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
  wstETH: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
  lidoRelayer: '0xdcdbf71A870cc60C6F9B621E28a7D3Ffd6Dd4965',
  balancerHelpers: '0x5aDDCCa35b7A0D07C74063c48700C8590E87864E',
  batchRelayer: '0xfeA793Aa415061C483D2390414275AD314B3F621',
  veBAL: '0xC128a9954e6c874eA3d62ce62B468bA073093F25',
  gaugeController: '0xC128468b7Ce63eA702C1f104D55A2566b13D3ABD',
  gaugeFactory: '0x4E7bBd911cf1EFa442BC1b2e9Ea01ffE785412EC',
  balancerMinter: '0x239e55F427D44C3cc793f49bFB507ebe76638a2b',
  tokenAdmin: '0xf302f9F50958c5593770FDf4d4812309fF77414f',
  veDelegationProxy: '0x6f5a2eE11E7a772AeB5114A20d0D7c0ff61EB8A0',
  veBALHelpers: '0x8e5698dc4897dc12243c8642e77b4f21349db97c',
  feeDistributor: '0xD3cf852898b21fc233251427c2DC93d3d604F3BB',
  feeDistributorDeprecated: '0x26743984e3357eFC59f2fd6C1aFDC310335a61c9',
  faucet: '',
};

export default contracts;
